import { render, staticRenderFns } from "./kbank2.vue?vue&type=template&id=04e2ff3a&scoped=true"
import script from "./kbank2.vue?vue&type=script&lang=js"
export * from "./kbank2.vue?vue&type=script&lang=js"
import style0 from "./kbank2.vue?vue&type=style&index=0&id=04e2ff3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2ff3a",
  null
  
)

export default component.exports